import axios from "axios";

let BASE_URL;
switch (process.env.REACT_APP_ENV) {
  case "PRODUCTION":
    BASE_URL = process.env.REACT_APP_AUTH_PRODURL;
    break;
  case "QA":
    BASE_URL = process.env.REACT_APP_AUTH_QA_URL;
    break;
  case "WEBC":
    BASE_URL = process.env.REACT_APP_AUTH_APIURL;
    break;
  default:
    // BASE_URL = process.env.REACT_APP_AUTH_APIURL;
    BASE_URL = process.env.REACT_APP_AUTH_UAT_URL;
    break;
}

let token = "";

export const getAuthAxiosInstance = async () => {
  try {
    token = localStorage.getItem("USER_ACCESS_TOKEN_CARIBOU");
  } catch (e) {
  } finally {
    const instance = axios.create({
      baseURL: BASE_URL,

      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Api-Key":
          process.env.REACT_APP_ENV === "PRODUCTION"
            ? process.env.REACT_APP_AUTH_PRODUCTION_API_KEY
            : process.env.REACT_APP_AUTH_WEBC_API_KEY,
        // "X-Caribou-Canary": "c7f3a9e2",
      },
    });
    instance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error?.response) {
          if (error?.response?.status === 401) {
            localStorage.clear("USER_ACCESS_TOKEN_CARIBOU");
            localStorage.clear("dashboard_permissions");
            localStorage.clear("productDetailsData");
            localStorage.clear("shopData");
            localStorage.clear("USER_DETAILS");
            window.location.href = "/login";
          }
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }
};
